<template>
  <div class="navbar-academy" :class="{ 'navbar-academy--dark': darkEnabled }">
    <div class="menu-left" :class="{ menuIsOpen: menuIsOpen }">
      <img src="@/assets/img/logo-academy.svg" id="logo" />

      <div class="voltar" @click="voltarPortal">
        <h3>Voltar ao portal</h3>
        <i class="fas fa-door-closed"></i>
      </div>

      <div class="loading" v-if="!sections.length">
        <img src="@/assets/img/loading.svg" />
      </div>

      <div class="container-principal" v-if="sections.length">
        <div v-for="section in sections" :key="section.idSection">
          <div class="titulo">
            <h3>{{ section.title }}</h3>
            <span></span>
          </div>

          <ul class="conteudo">
            <li
              v-for="(lesson, index) in section.lessons"
              :key="lesson.id"
              @click="irParaOVideo(section.idSection, lesson.id)"
              :class="videoAtual(index, section, lesson.id)"
            >
              <i class="fas fa-video"></i>
              <span>{{ lesson.title }}</span>
            </li>

            <li
              class="avaliacao"
              v-if="section.evaluation && section.evaluation.questions"
              @click="irParaAvaliacao(section.idSection)"
              :class="videoAtual(null, section, 'test')"
            >
              <i class="fas fa-book"></i>
              <span>Avaliação</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["menuIsOpen", "getVideosAcademy", "darkEnabled"]),
    sections() {
      return this.getVideosAcademy || [];
    }
  },
  methods: {
    voltarPortal() {
      this.$router.push("/fornecedor/inicio");
    },
    irParaOVideo(sectionId, lessonId) {
      const rotaAtual = this.$route.path;
      const proximoVideo = `/ead/section/${sectionId}/lesson/${lessonId}`;
      if (rotaAtual === proximoVideo) return;
      this.$router.push(proximoVideo);
    },
    irParaAvaliacao(sectionId) {
      const rotaAtual = this.$route.path;
      const avaliacao = `/ead/section/${sectionId}/test`;
      if (rotaAtual === avaliacao) return;
      this.$router.push(avaliacao);
    },
    videoAtual(index, section, lessonId) {
      const rotaAtual = this.$route.path.split("/");
      const marcarVideoAtual =
        section.idSection === rotaAtual[3] && rotaAtual[5] === lessonId;
      const isAvaliacao =
        section.idSection === rotaAtual[3] &&
        rotaAtual.pop() === "test" &&
        lessonId === "test";
      return isAvaliacao ||
        (marcarVideoAtual && section.lessons.length !== index)
        ? "conteudo-escolhido"
        : "";
    }
  }
};
</script>

<style scoped>
h3 {
  padding-left: 15px;
}

li {
  list-style-type: none;
  border-bottom: 1px solid #e4e5e7;
  padding: 10px 10px 10px 15px;
  color: #6a6c6f;
  text-transform: none;
  font-weight: 600;
}

li:hover {
  background: #e4e5e7;
  transition: 0.3s all ease;
  cursor: pointer;
  border-color: #d3d4d6;
}

#logo {
  width: 75%;
  padding-bottom: 35px;
}

.menu-left {
  width: 19em;
  height: 100vh;
  padding-top: 35px !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container-principal {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  position: relative;
}

.titulo {
  height: 45px;
  display: flex;
  align-items: center;
  background: var(--primary-color, #00558e);
  color: white;
  position: relative;
}

.titulo span {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  background-color: #01426f;
  border-radius: 50%;
}

.conteudo {
  padding: 0;
  text-align: left;
  font-size: 15px;
}

.conteudo li {
  cursor: pointer;
}

.conteudo span {
  padding-left: 15px;
}

.conteudo-escolhido {
  background: rgba(167, 167, 167, 0.66) !important;
  border-right: 7px solid var(--primary-color, #276baf);
  color: white !important;
}

.avaliacao {
  color: var(--primary-color, #276baf) !important;
}

.voltar {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  background-color: #50b748;
  color: white;
  position: relative;
  cursor: pointer;
}

.voltar i {
  position: absolute;
  right: 15px;
}

.loading {
  position: absolute;
  top: 50%;
}
</style>

<style lang="scss">
/* Sem scoped: tema escuro precisa vencer estilos globais e alinhar ao darkEnabled */
.navbar-academy.navbar-academy--dark .menu-left,
.v-application.theme--dark .navbar-academy .menu-left {
  background: var(--dark-surface, #1d1d1d) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  align-items: stretch;
}

.navbar-academy.navbar-academy--dark .container-principal,
.v-application.theme--dark .navbar-academy .container-principal {
  width: 100%;
  background: var(--dark-surface, #1d1d1d);
}

.navbar-academy.navbar-academy--dark .conteudo,
.v-application.theme--dark .navbar-academy .conteudo {
  background: var(--dark-surface, #1d1d1d);
}

.navbar-academy.navbar-academy--dark li,
.v-application.theme--dark .navbar-academy li {
  background: var(--dark-surface, #1d1d1d) !important;
  border-bottom-color: rgba(255, 255, 255, 0.12) !important;
  color: rgba(255, 255, 255, 0.87) !important;
}

.navbar-academy.navbar-academy--dark li:hover,
.v-application.theme--dark .navbar-academy li:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
}

.navbar-academy.navbar-academy--dark .conteudo li i,
.v-application.theme--dark .navbar-academy .conteudo li i {
  color: rgba(255, 255, 255, 0.65);
}

.navbar-academy.navbar-academy--dark .titulo span,
.v-application.theme--dark .navbar-academy .titulo span {
  background-color: rgba(0, 0, 0, 0.35);
}

.navbar-academy.navbar-academy--dark .conteudo-escolhido,
.v-application.theme--dark .navbar-academy .conteudo-escolhido {
  background: rgba(100, 181, 246, 0.28) !important;
  border-right: 7px solid var(--primary-color) !important;
  color: #fff !important;
}

.navbar-academy.navbar-academy--dark .avaliacao:not(.conteudo-escolhido),
.v-application.theme--dark .navbar-academy .avaliacao:not(.conteudo-escolhido) {
  color: var(--primary-color) !important;
}

.navbar-academy.navbar-academy--dark .avaliacao.conteudo-escolhido,
.v-application.theme--dark .navbar-academy .avaliacao.conteudo-escolhido {
  color: #fff !important;
}

.navbar-academy.navbar-academy--dark .voltar,
.v-application.theme--dark .navbar-academy .voltar {
  background-color: var(--secondary-color, #50b748) !important;
  color: #fff !important;
}

.navbar-academy.navbar-academy--dark #logo,
.v-application.theme--dark .navbar-academy #logo {
  background: transparent;
}
</style>
